import type { ReceiptKind, ReceiptStatus } from './types';

// UI-only display mapping (no DB change). The backend enum stays
// `Deposit | Final`. Terminology (updated): a Deposit is a receipt (money
// received up front); a Final is an *invoice* — a bill — until it is Paid, at
// which point it becomes a receipt. `kindLabel` gives the kind-only document
// type; `documentLabel` is status-aware and preferred wherever a status is on
// hand. Supersedes the v1.2 "always call Final a Receipt" decision.
const KIND_LABELS: Record<ReceiptKind, string> = {
  Final: 'Invoice',
  Deposit: 'Deposit'
};

/** Kind-only document type (no status) — a Final is an "Invoice". */
export function kindLabel(kind: ReceiptKind): string {
  return KIND_LABELS[kind] ?? kind;
}

/**
 * Status-aware document label: a Final is an "Invoice" until Paid, then a
 * "Receipt"; a Deposit is always a "Deposit".
 */
export function documentLabel(kind: ReceiptKind, status: ReceiptStatus): string {
  if (kind === 'Deposit') return 'Deposit';
  return status === 'Paid' ? 'Receipt' : 'Invoice';
}

/** Selectable kinds for the create form, in display order, with their labels. */
export const KIND_OPTIONS: Array<{ value: ReceiptKind; label: string }> = [
  { value: 'Final', label: 'Invoice' },
  { value: 'Deposit', label: 'Deposit' }
];
